<template lang="html">
    <div class="form-group" :class="[col ? col : 'col-lg-12']">
        <label :for="name">{{ label }} <span v-if="required">*</span></label>
        <input
            class="form-control"
            :class="[error ? 'has-error' : '']"
            :id="name"
            :value="value"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            type="text">
        <error :error="error"></error>
    </div>
</template>

<script>
import Error from "./Error.vue"

export default {
    components: {
        Error
    },
    props: {
        label: String,
        name: String,
        value: String,
        error: String,
        required: Boolean,
        col: String,
        placeholder:String,
    }
}
</script>
